module.exports = __webpack_public_path__ + "img/img17.9d7c56db.svg";